
import { useStrategyStats } from "./useStrategyStats";
import StatItem from "./StatItem";
import ProStatItem from "./ProStatItem";

interface StrategyStatsProps {
  riskLevel?: number;
  winRate?: number | null;
  maxDrawdown?: number | null;
  tradesWon?: number | null;
  tradesLost?: number | null;
  aum?: number | null;
  pnlRatio?: number | null;
  timespan?: number | null;
  isPro?: boolean;
  infoIconColor?: string;
}

export const StrategyStats = ({ 
  riskLevel, 
  winRate, 
  maxDrawdown,
  tradesWon,
  tradesLost,
  aum,
  isPro = false,
  pnlRatio,
  timespan,
  infoIconColor = "#555555"
}: StrategyStatsProps) => {
  const { stats } = useStrategyStats({ 
    riskLevel, 
    winRate, 
    maxDrawdown, 
    tradesWon, 
    tradesLost, 
    aum, 
    isPro,
    pnlRatio,
    timespan,
    infoIconColor
  });

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-4">
      {stats.map((stat, index) => (
        isPro ? (
          <ProStatItem
            key={index}
            label={stat.label}
            value={stat.value}
            icon={stat.icon}
            valueColor={stat.valueColor}
            tooltip={stat.tooltip}
            infoIconColor={infoIconColor}
          />
        ) : (
          <StatItem
            key={index}
            label={stat.label}
            value={stat.value}
            icon={stat.icon}
            valueColor={stat.valueColor}
            tooltip={stat.tooltip}
            infoIconColor={infoIconColor}
          />
        )
      ))}
    </div>
  );
};
